// extracted by mini-css-extract-plugin
module.exports = {"textData":"style_textData__lpAIw","link":"style_link__oZ7xq"};